import { Component } from 'react';
import { Row, Col } from 'antd';
import User from "@/config/user";
import { convertBase64ToPicture } from "@/lib/uploadFunction";

const { getAccountInfo } = User;

interface state {
  dataObject: any;
}

class ModalStudentCard extends Component<{}, state> {
  state = {
    dataObject: {} as never as any,
  };

  componentDidMount() {
    this.getAccountInfo();
  }

  getAccountInfo = () => {
    getAccountInfo().then((res: any) => {
      this.setState({ dataObject: res?.value ?? {} });
    });
  }

  render() {
    const { dataObject } = this.state;
    const { idCard, qrCode } = dataObject;

    return (Object.keys(dataObject).length > 0 &&
      <Row justify="space-around">
        <Col>
          <img height="200px" width="200px" alt="avatar" src={convertBase64ToPicture(idCard)} />
        </Col>
        <Col>
          <img height="200px" width="200px" alt="qrcode" src={convertBase64ToPicture(qrCode)} />
        </Col>
      </Row>
    );
  }
}

export default ModalStudentCard;